import ApartmentAccessGroupsSettings from './ApartmentAccessGroupsSettings';

export default ApartmentAccessGroupsSettings;
